import React, { CSSProperties } from 'react'

import House from '../assets/svgs/House'
import Apartment from '../assets/svgs/Apartment'
import Studio from '../assets/svgs/Studio'
import COLORS from '../styles/colors'

const PropertyTypeOption = ({ Icon, text, value, onClick, propertyTypes, extraIconStyles }) => (
  <button style={styles.switchButton(propertyTypes.includes(value))} onClick={() => onClick(value)}>
    <Icon
      style={extraIconStyles}
      color={propertyTypes.includes(value) ? COLORS.greyscale.white : COLORS.gray}
    />
    <p style={styles.switchLabel(propertyTypes.includes(value))}>{text}</p>
  </button>
)

enum PROPERTY_TYPES {
  apartment = 'apartment',
  house = 'house',
  studio = 'studio',
}

type Props = {
  propertyTypes: string[]
  onClick: (value: PROPERTY_TYPES) => void
}

const PropertyTypeMultiSelect = (props: Props) => (
  // @ts-ignore
  <div style={styles.selectContainer}>
    <PropertyTypeOption
      value='apartment'
      Icon={Apartment}
      onClick={props.onClick}
      extraIconStyles={styles.icon}
      propertyTypes={props.propertyTypes}
      text='Apartamento'
    />
    <PropertyTypeOption
      value='house'
      Icon={House}
      onClick={props.onClick}
      extraIconStyles={styles.icon}
      propertyTypes={props.propertyTypes}
      text='Casa'
    />
    <PropertyTypeOption
      value='studio'
      Icon={Studio}
      onClick={props.onClick}
      propertyTypes={props.propertyTypes}
      extraIconStyles={styles.studioIcon}
      text='Kitnet/Studio'
    />
  </div>
)

const styles = {
  selectContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto',
  },
  // @ts-ignore
  switchButton: (selected) =>
    ({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '33%',
      height: 93,
      backgroundColor: selected ? COLORS.brand.primaryDark : 'transparent',
      border: `1px solid ${selected ? COLORS.brand.primaryDark : COLORS.greyscale.medium}`,
      borderRadius: 2,
      marginLeft: -3,
      cursor: 'pointer',
      margin: '0 4px',
    } as CSSProperties),
  // @ts-ignore
  switchLabel: (selected) => ({
    color: selected ? COLORS.greyscale.white : COLORS.gray,
    fontSize: 12,
    fontWeight: 700,
    marginTop: 10,
  }),
  icon: {
    height: 40,
    width: 40,
  },
  studioIcon: {
    height: 40,
    width: 70,
  },
}

export default PropertyTypeMultiSelect
